import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Button from "../../../Components/Control/Button";
import Notif from "../../../Components/Notif";
import {connect} from "react-redux";
import Perms from "../../../Perms";
import Resource from "../../../Resource";

class ModalProductList extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        props.refer.current = this;

        this.state = {
            loading: false,
            resolve: _ => null,
            reject: _ => null,
            grid: {
                defaultColDef: {
                    floatingFilter: false
                },
                columnDefs: [{
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    valueGetter: row => row.data.productBloodGroupStr || row.data.bloodGroupStr,
                    cellClass: 'green'
                }, {
                    field: 'productExpireDate',
                    headerName: 'تاریخ انقضا فرآورده',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    field: 'productCreateDateTime',
                    headerName: 'زمان ثبت',
                    valueGetter: gridDateTime.bind(this),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    headerName: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state',
                    valueGetter: row => {
                        const expire = {
                            1: 'نزدیک به انقضا',
                            2: 'منقضی شده'
                        }[row.data.isProductExpiredTny] || null;

                        if (expire)
                            return [row.data.productStatusStr, expire];
                        else
                            return row.data.productStatusStr || row.data.statusStr;
                    }
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 190,
                    hide: !(Perms().BLOOD_BANK_INCOMING.VIEW),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            <GridState theme={'green'}>{row.data.productStatusStr}</GridState>
                            {/* eslint-disable-next-line eqeqeq */}
                            {row.data?.isProductExpiredTny == 1 && <GridState theme={'yellow'}>نزدیک به انقضا</GridState>}
                            {/* eslint-disable-next-line eqeqeq */}
                            {row.data?.isProductExpiredTny == 2 && <GridState theme={'red'}>منقضی شده</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {Perms().BLOOD_BANK_INCOMING.VIEW && <GridButton type={"button"} theme={'select'} title={'انتخاب فرآورده'} onClick={this.select.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                onRowDoubleClicked: row => {
                    this.select(row.data);
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'انتخاب فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CLICKER.BLACK}" alt="">`,
                            action: this.select.bind(this, params.node.data),
                            disabled: !Perms().BLOOD_BANK_INCOMING.VIEW
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre'}>نشان دهنده گروه خونی فرآورده می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'green'}>موجود</GridState> فرآورده قابل استفاده می باشد.</p>
                                <p><GridState theme={"yellow"}>نزدیک به انقضا</GridState> فرآورده به تاریخ انقضا خود در سامانه نزدیک می شود.</p>
                                <p><GridState theme={'red'}>منقضی شده</GridState> تاریخ انقضا فرآورده در سامانه گذشته است.</p>
                                <p><GridState theme={'green'}>رزرو شده</GridState> فرآورده برای بیمار رزرو شده است.</p>
                                <p><GridState theme={'green'}>آماده ارسال</GridState> فرآورده جهت ارسال به بخش آماده شده است.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'select'}/>برای انتخاب یک فرآورده می توانید از این طریق اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            gridContext: null
        };

        this.ref = {
            modal: React.createRef(),
            grid: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        const {state} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalProductList'}
                   size={'large'}
                   title={'لیست فرآورده‌ها'}
                   loading={state.loading}>
                <ModalContent>
                    <Group className={'ModalProductList-group fb-20'}>
                        <Grid id={'hospitalInventoryList'} refer={this.ref.grid } {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
        </React.Fragment>;
    }

    updateGrid(data, action) {
        this.setState({
            rowData: [],
            loading: 'در حال دریافت اطلاعات'
        });

        Hospital.incomingList({productNumber:data?.productNumber})
            .then(list => {
                this.setState({
                    rowData: list,
                    loading: false
                });
            })
            .catch(message => {
                new Notif({message, theme: 'error',}).show();

                this.setState({loading: false});
            });
    }

    gridReadyHandler(params) {
        this.setState({gridContext: params});
    }

    close() {
        this.ref.modal.current.close();

        this.props.onClose();
    }

    open(data, action) {
        return new Promise((resolve, reject) => {
            this.ref.modal.current.open();

            this.setState({data, action, resolve, reject});

            this.updateGrid(data, action);
        });
    }

    select(data) {
        this.close();

        this.state.resolve(data);
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalProductList)